import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ArticulosService } from 'src/app/services/articulos.service';

@Component({
  selector: 'myApp-nuevo-cliente',
  templateUrl: './nuevo-cliente.component.html',
  styleUrls: ['./nuevo-cliente.component.scss'],
})
export class NuevoClienteComponent implements OnInit {
  @Input() cl;
  cliente = {
    cl_nombre: '',
    cl_telefono: 0,
    cl_codigo: '',
  }
  constructor(
              private clServ: ArticulosService,
              private mdc: ModalController,
  ) { }

  async ngOnInit() {
    console.log(this.cl)
    if(this.cl){
      let nuevo = {
        cl_nombre: this.cl.cl_nombre,
        cl_telefono: this.cl.cl_telefono,
        cl_codigo: this.cl.cl_codigo,
      }
      this.cliente = nuevo;
    
    }
    else{
      console.log('sin Cl')
    }
  }


  async guardar(){
    if(this.cliente.cl_codigo){
      this.clServ.updateCliente(this.cliente).then(data =>{
        this.mdc.dismiss();
      })
    }
    else{
      this.clServ.addCliente(this.cliente).then(data =>{
        this.mdc.dismiss();
      })
    }

  }

  cerrar(){
    this.mdc.dismiss();
  }

}
